<template>
    <div class="card" v-if="contactosTable">
        <DataTable  :value="contactosTable" 
                            rowGroupMode="subheader" 
                            groupRowsBy="tipo"
                            sortMode="single" 
                            :sortOrder="-1"
                            sortField="tipo" 
                            :expandableRowGroups="true" 
                            :expandedRowGroups.sync="expandedRowGroups"
                            class="whiteBG noHeader"
                            >

            <template #header>
                <div class="table-header-container">
                   <span class="leftAlign">
                       <button class="p-row-toggler p-link" @click="expandOrCollapse()"><span :class="expandClass"></span></button>
                    </span>
                    <span v-if="titleHeader">
                        {{titleHeader}}    
                    </span>
                    <span v-else>    
                        {{$t('contacto.titulo.lista')}}
                    </span>    
                </div>
            </template>

            <Column field="tipo" :header="$t('contacto.tipo')" >
                <template #header>
                    <button class="p-row-toggler p-link" @click="expandOrCollapse()"><span :class="expandClass"></span></button>
                </template>
            </Column>

            <Column field="texto">
                <template #body="slotProps">
                    <div v-if="slotProps.data.texto">
                        <span class="paddingLR">
                            {{slotProps.data.texto}} 
                            <i v-if="slotProps.data.activo" class="pi pi-tag" v-tooltip.bottom="$t('contacto.notificaciones.tooltip')"></i>
                        </span>
                        <span class="rightAlign" v-if="permitirEditarPermisos">
                            <Button :disabled="slotProps.data.activo" @click.prevent="mostrarConfirmacionBorrado(slotProps.data.object)" v-tooltip.right="$t('common.buttons.eliminar')" :label="$t('common.buttons.eliminar')" class="p-button-text-danger p-button-icon-only rightAlign transparent" icon="pi pi-trash"/>
                            <Button @click.prevent="modificaContacto(slotProps.data.tipoContacto, slotProps.data.object)" v-tooltip.right="$t('common.buttons.edit')" :label="$t('common.buttons.edit')" class="p-button-text p-button-icon-only rightAlign transparent" icon="pi pi-pencil"/>
                        </span>
                    </div>                   
                    <div v-else>
                        <span class="paddingLR">
                            {{slotProps.data.hasContacts ? '' : $t('common.noResultados')}}
                        </span>
                        <span class="rightAlign" v-if="permitirCrearContactos(slotProps.data.hasContacts)">
                            <Button @click.prevent="altaContacto(slotProps.data.tipoContacto)" v-tooltip.right="$t('common.buttons.anadir')" :label="$t('common.buttons.anadir')" class="p-button-text p-button-icon-only  marginLR transparent" icon="pi pi-plus"/>
                        </span>         
                    </div>
                </template>
            </Column>

            
            <template #groupheader="slotProps">
                <span>
                  
                    <label v-if="slotProps.data.length == 1"><b>{{slotProps.data.tipo}} :</b> {{slotProps.data.texto}}</label>
                    <b v-else>{{slotProps.data.tipo}} <b v-if="slotProps.data.length > 0"> ({{slotProps.data.length}})</b></b>
                   
                </span>
            </template>
        </DataTable>

        <Dialog :header="$t('common.mensajes.confirmacionBorrado')" :visible.sync="displayConfirmation" :style="{width: '350px'}" :modal="true"
                v-if="selectedContacto">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
                <span>{{$t('contacto.mensajes.borrado')}}?</span>
            </div>
            <template #footer>
                <Button :label="$t('common.yes')" icon="pi pi-check" @click="borrarContacto(selectedContacto.id)" class="" autofocus />
                <Button :label="$t('common.no')" icon="pi pi-times" @click="cerrarModal()" class="p-button-secondary"/>
            </template>
        </Dialog>

        <EditarContacto :id="id" :contacto="selectedContacto" :tipoContacto="selectedTipoContacto" v-on:close-dialog="cerrarModal()" v-if="mostrarEditar" :displayDialog="mostrarEditar" :key="'mostrarEditar' + mostrarEditar"/>
        <AltaContacto :tipoContacto="selectedTipoContacto" :id="id" :propietario="propietario" v-on:close-dialog="cerrarModal()" v-if="mostrarAlta" :displayDialog="mostrarAlta" :key="'mostrarAlta' + mostrarAlta"/>

    </div>
</template>

<script>
import AddressesMixin from '@/utils/addresses';
import AbilitiesMixin from '@/utils/ability';
import StringsMixin from '@/utils/strings';
import EditarContacto from '@/components/portal-gran-cliente/editar/EditarContacto.vue';
import AltaContacto from '@/components/portal-gran-cliente/editar/AltaContacto.vue';
import {BORRAR_CONTACTO} from '@/graphQLQueries/ContactoQueries';
import {GET_CONTACTOS} from '@/graphQLQueries/ContactoQueries';
import {CLASS_COLLAPSED_ALL,CLASS_EXPANDED_ALL} from '@/resources/constants';

export default {
    name: 'ListaContactos',
    components:{
        'EditarContacto': EditarContacto,
        'AltaContacto': AltaContacto
    },
    props: {
        id: Number,
        propietario: String,
        permitirEditar: Boolean,
        titleHeader: String
    },
    mixins: [AddressesMixin, StringsMixin, AbilitiesMixin],
    data() {
        return{
            contactosTable: null,
            contactos: null,
            //expandedRowGroups: [this.$t('contacto.emails'), this.$t('contacto.telefonos'), this.$t('contacto.direcciones')],
            expandedRowGroups: [],
            permitirEditarPermisos: Boolean,
            permitirCrear: Boolean,
            displayConfirmation: false,
            mostrarEditar: false,
            mostrarAlta: false,
            selectedContacto: null,
            selectedTipoContacto: null,
            expandClass: CLASS_COLLAPSED_ALL         
         }
    },
    created() {
        this.getContactos()
        this.permitirEditarPermisos = this.checkAbility('editarCliente') && this.permitirEditar
        this.permitirCrear = this.checkAbility('editarCliente') && this.permitirEditar
        this.createContactosTable()
    },
    mounted() {
        
    },
    methods: {
        createContactosTable(){
            if(this.contactos){
            this.contactosTable = []
            var i;
                if(this.contactos.emails.length){
                    for(i in this.contactos.emails){
                        this.contactosTable.push({  "tipo": this.$t('contacto.emails'), 
                                                    "texto": this.contactos.emails[i].valor.email, 
                                                    "tipoContacto": "email",
                                                    "object": this.contactos.emails[i],
                                                    "length": this.contactos.emails.length,
                                                    "activo": this.contactos.emails[i].activo})
                    }
                }
                if(this.contactos.telefonos.length){
                    for(i in this.contactos.telefonos){
                        this.contactosTable.push({  "tipo": this.$t('contacto.telefonos'), 
                                                    "texto": this.contactos.telefonos[i].valor.telefono, 
                                                    "tipoContacto": "telefono",
                                                    "object": this.contactos.telefonos[i],
                                                    "length": this.contactos.telefonos.length,
                                                    "activo": this.contactos.telefonos[i].activo})
                    }
                }
                if(this.contactos.direcciones.length){
                    for(i in this.contactos.direcciones){
                        var jsonAddress = this.contactos.direcciones[i].valor;
                        jsonAddress["tipoDireccion"] = this.contactos.direcciones[i].literalTipoVia.valor;
                        jsonAddress["pais"] = this.contactos.direcciones[i].literalPais.valor;
                        jsonAddress["provincia"] = this.contactos.direcciones[i].literalProvincia.valor;
                        this.contactosTable.push({  "tipo": this.$t('contacto.direcciones'), 
                                                    "texto": this.getFullAddress(jsonAddress), 
                                                    "tipoContacto": "direccion",
                                                    "object": this.contactos.direcciones[i],
                                                    "length": this.contactos.direcciones.length,
                                                    "activo": this.contactos.direcciones[i].activo})
                    }
                }
                // Añadir columnas de añadir nuevo
                if(this.permitirEditarPermisos){
                    this.contactosTable.push({"tipo":this.$t('contacto.emails'), "tipoContacto": "email", "hasContacts": this.contactos.emails != undefined && this.contactos.emails.length > 0})
                    this.contactosTable.push({"tipo":this.$t('contacto.telefonos'), "tipoContacto": "telefono", "hasContacts": this.contactos.telefonos != undefined && this.contactos.telefonos.length > 0})
                    this.contactosTable.push({"tipo":this.$t('contacto.direcciones'), "tipoContacto": "direccion", "hasContacts": this.contactos.direcciones != undefined && this.contactos.direcciones.length > 0})
                }
            }
            
        },
        expandOrCollapse(){
          this.expandClass.includes('pi-chevron-right') == true ? this.expandAll() : this.collapseAll();
        },
        expandAll() {
            this.expandClass = CLASS_EXPANDED_ALL 
            this.expandedRowGroups = [this.$t('contacto.emails'), this.$t('contacto.telefonos'), this.$t('contacto.direcciones')];
        },
        collapseAll() {
            this.expandClass = CLASS_COLLAPSED_ALL
            this.expandedRowGroups = null;
        },
        altaContacto(selectedTipoContacto) {
            this.selectedTipoContacto = selectedTipoContacto
            this.mostrarAlta = true
        },
        modificaContacto(selectedTipoContacto, selectedContacto) {
            this.selectedTipoContacto = selectedTipoContacto
            this.selectedContacto = selectedContacto
            this.mostrarEditar = true
        },
        cerrarModal(){
            this.displayConfirmation = false
            this.mostrarEditar = false
            this.mostrarAlta = false

            this.selectedContacto = null
            this.selectedTipoContacto = null                

            this.getContactos()
        },
        mostrarConfirmacionBorrado(selectedContacto){
            this.selectedContacto = selectedContacto
            this.displayConfirmation = true
        },            
        borrarContacto(object){
            this.$apollo.mutate({
                mutation: BORRAR_CONTACTO,
                variables: {
                    id: object
                }
            }).then(() => {
                this.getContactos()
                this.cerrarModal()
            }).catch((error) => {
                // Error
                console.error(error)
            })
        },
        getContactos(){
            this.$apollo.query({
                query: GET_CONTACTOS,
                variables: {
                    id: this.id,
                    tipoPropietario: this.propietario,
                    idioma: this.$i18n.locale
                },
                fetchPolicy: 'no-cache'
            }).then((data) => {
                this.contactos = data.data.contactos
                this.createContactosTable()
            }).catch((error) => {
                // Error
                console.error(error)
            })
        },
        permitirCrearContactos(hasContacts){
         if(this.propietario == 'reclamacion' && hasContacts)
            return false

         return this.permitirCrearContactos  
        }
    }
}    
</script>

<style scoped>
   .paddingLR{
        padding-left: 24px;
        padding-right: 24px;
    }
    .whiteBG{
        border-color: white;
        background-color: white;
        /* border-right: 1px solid #d5d5d5; */
    }
    .marginLR{
        margin-left: 5px;
        margin-right: 5px;
    }
    .marginLeft{
        margin-left: 28px;
    }
</style>
